export default function setSearchCountryAction(searchCountry) {
    return {
        type: 'SET_SEARCH_COUNTRY',
        payload: searchCountry
    }
}